import { Component, Input, OnChanges, OnInit, type SimpleChanges } from '@angular/core';
import {
  CurrencyCode,
  DataArgs,
  EnterpriseSearchService,
  FlightJourney,
  FlightOptions,
  InputFlightJourney,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';
import { RouteHappyResults } from '@sabstravtech/obtservices/base';
import _ from 'lodash';

@Component({
  selector: 'app-flight-amenities',
  templateUrl: './flight-amenities.component.html',
  styleUrls: ['./flight-amenities.component.scss'],
  standalone: false
})
export class FlightAmenitiesComponent
  extends WithSubscriptionComponent
  implements OnInit, OnChanges
{
  @Input() flights: FlightJourney[] = [];
  @Input() supplier = '';
  @Input() currency: CurrencyCode;
  @Input() extraOptions: FlightOptions;
  routeHappyResults: RouteHappyResults;
  loadingRouteHappy = false;

  freeCarryOnBag: { text: string } | null = null;
  freeCheckedBag: { text: string } | null = null;

  constructor(public searchService: EnterpriseSearchService) {
    super();
  }

  ngOnInit() {
    this.updateFreeBaggage();
    this.getRouteHappyInfo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['extraOptions']) {
      this.updateFreeBaggage();
    }
  }

  private updateFreeBaggage(): void {
    this.freeCarryOnBag = this.extraOptions?.ancillary?.find((item) => item.price === 0) || null;
    this.freeCheckedBag = this.extraOptions?.luggage?.find((item) => item.price === 0) || null;
  }

  getRouteHappyInfo() {
    this.loadingRouteHappy = true;
    const journeys = _.clone(this.flights);
    journeys.forEach((journey) => {
      const unwantedProps = [
        'journeyLegs',
        'co2PerItem',
        'co2PerPassenger',
        'journeyHash',
        'safRating',
        'segmentGroup'
      ];
      unwantedProps.forEach((unwantedProp) => {
        delete journey[unwantedProp];
      });
    });

    const dataArgs: DataArgs = {
      itineraries: [
        {
          journeys: journeys as InputFlightJourney[]
        }
      ],
      source: this.supplier
    };
    this.subscribe(
      this.searchService.getRouteHappy(dataArgs, this.currency),

      {
        next: (data: RouteHappyResults) => {
          this.loadingRouteHappy = false;
          this.routeHappyResults = data;
        },
        error: () => {
          this.loadingRouteHappy = false;
        }
      }
    );
  }
}
